import { render, staticRenderFns } from "./HockeyMatches.vue?vue&type=template&id=ea65c84c&"
import script from "./HockeyMatches.vue?vue&type=script&lang=js&"
export * from "./HockeyMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports